import {Component, Input, OnInit, ElementRef ,ViewChild, PLATFORM_ID} from '@angular/core';
import {ApplicationFormComponent} from '../application-form/application-form.component';
import {MessagesService} from '../../services/messages.service';
import * as jspdf from 'jspdf'; 
import * as  html2canvas from 'html2canvas';
import { FormGroup, FormControl,Validators, FormArray } from '@angular/forms';
import {ReCaptcha2Component, NgxCaptchaModule} from 'ngx-captcha';
import {CustomerFormService} from '../../services/customer-form.service';
import {REGEX} from '../../shared/regex.util';
import {ClrLoadingState} from '@clr/angular';
import {forkJoin, Observable} from 'rxjs';
import {ActivatedRoute, Router,NavigationEnd} from '@angular/router';
import { resolve, reject } from 'q';
import { ViewportScroller } from '@angular/common';
import {Location} from '@angular/common';
import * as Bowser from "bowser";

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css'],
  providers: [NgxCaptchaModule, ReviewComponent]
})
export class ReviewComponent implements OnInit {
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;

  //Build Review Form

  customerForm: FormGroup;
  PROSPECT_ADDRESS: FormArray;
  PROSPECT_REFERENCE: FormArray;
  PROSPECT_CONTACT: FormArray;
  reviewForm: FormGroup;
  APPLICANT_NAME:string;
  DBA_NAME: string
  SOURCE_NAME: string
  PST_NUM: string
  TIRE_STEWARDSHIP: string
  PREMISIS: string
  RENTAL_PAYMENT: string
  OWNER_FILED_BANKRUPT: string
  BANKRUPT_REASON: string
  TRUSTEE_NAME: string
  ACCT_REQUESTED: string
  BSNS_WITH_NTD:  string
  PRVS_BSNS_ACCT_NUM: string
  TC_DATE: string
  EMAIL_CORRESPONDENCE: string
  ATD_EMP_NUM: string
  PROCESS_STATUS: string
  PREV_ADDRR_LESS_THAN_3YR: string
  TERMS_CONDITIONS_ACCEPT: string
  myRecaptcha : string
  STAGE_CUSTOMER_NUM: string
  LIVE_CUSTOMER_NUM: string
  OWNER_FIRST_NAME: string
  OWNER_LAST_NAME: string
  MYSQL_ORG_ID: string;
  PHONE_AREA_CODE: string;
  PHONE_NUMBER: string;
  ADDRESS_LINE1: string;
  ADDRESS_LINE2: string;
  STATE: string;
  CITY: string;
  COUNTY: string;
  POSTAL_CODE: string;
  COUNTRY:string;
  BILL_ADR_SAME_SHIP_ADR: string;
  //Shipping
  S_ADDRESS_LINE1: string;
  S_ADDRESS_LINE2: string;
  S_STATE: string;
  S_CITY: string;
  S_COUNTY: string;
  S_POSTAL_CODE: string;
  S_COUNTRY:string;

  //Communications
  EMAIL_ADDRESS: string;
  //BUSINESS
  BUSINESS_TYPE: string;
  //Business Identification
  STATE_ORG_ID: string
  JGZZ_FISCAL_CODE: string
  DNB_NUMBER: string
  //Customer Info
  C_PHONE_AREA_CODE: string;
  C_PHONE_NUMBER: string;
  C_EMAIL_ADDRESS: string;
   //Principle owner# 1
   P1_REF_NAME: string;
   P1_ADDRESS_LINE1: string;
   P1_ADDRESS_LINE2:string;
   P1_CITY: string;
   P1_STATE: string;
   P1_COUNTY: string;
   P1_POSTAL_CODE: string;
   P1_COUNTRY : string;
   P1_PHONE_AREA_CODE: string;
   P1_PHONE_NUMBER: string;
   P1_EMAIL_ADDRESS: string;
   //Principle owner# 2
   P2_REF_NAME: string;
   P2_PHONE_AREA_CODE: string;
   P2_PHONE_NUMBER: string;
   P2_EMAIL_ADDRESS: string;
   //TAX_EXEMPT
   IS_CUST_TAX_EXEMPT: string;
   //Credit Application
   CUSTOMER_REQUESTED_CREDIT: string;
   CREDIT_LIMIT_REQUESTED: string;
   CUSTOMER_CREDIT_AUTHORIZED: string
   //Type of Business
   TYPE_OF_BUSINESS: string;
   TYPE_OF_BUSINESS_DESC: string;
   YRS_IN_BUSINESS: string;
   PO_REQUIRED: string
   EST_ANNUAL_PUR_VOL: string;
  //  DATE_BUSINESS_OPENED: string;
   currentDate: string = new Date().toLocaleDateString();
   //captcha
   public readonly siteKey = '6LdHn5sUAAAAAECrwsqUGbWrO2_y1NheVlXXVjvv';
   public captchaIsLoaded = false;
   public captchaSuccess = false;
   public captchaIsExpired = false;
   public captchaResponse?: string;
   //Docs
   showTC = false;
   showError = false;
   errorMessage: string;
   appDocB64: any;
   appDoc: any;
   blcDocB64: any;
   blcDocLabel: string;
   blcDoc: any;
   docError = false;
   blcDocObject: object = {};
   blcFileErrorMessage: string;
   pgErrorMessage: string;
   stateTaxFilesLabels: Array<string> = [];
   stateTaxFilesError: string;
   stateTaxFiles: Array<any> = [];
   stateTaxFilesObjects: Array<any> = [];
   mySQLOrgId: number;
   validateBtnState: ClrLoadingState = ClrLoadingState.DEFAULT;
   //Title
   APP_TITLE:string;
   //Remove Controls
   apRemoveControl: string;
   activateHeader: string;
   //State
   applicantState: string;
   shippingState: string;
   principleState: string;
   principleTwoState: string;
   //County
   applicantCounty: string;
   shippingCounty: string;
   principleCounty: string;
   principleTwoCounty: string;

   //MJF
   TAXABLE_ITEMS: string;
   TAX_EXEMPTION_NUMBER: string;
   TIRE_DISPOSAL_FEE: string;
   PROPERTY_DESCRIPTION: string;
   enableMjf:string;

   //TIME STAMP
   currentTime: any;
   activateTimeInterval: any;
   
  constructor( private messagesService: MessagesService,
    private customerService: CustomerFormService,
    private router: Router,
    private _location: Location) { 



    }

  handleReset(): void {
    this.captchaSuccess = false;
    this.captchaResponse = undefined;
    this.captchaIsExpired = false;
  }

  handleSuccess(captchaResponse: string): void {
    this.captchaSuccess = true;
    this.captchaResponse = captchaResponse;
    this.captchaIsExpired = false;
    this.validateCaptcha();
  }

  handleLoad(): void {
    this.captchaIsLoaded = true;
    this.captchaIsExpired = false;
  }

  handleExpire(): void {
    this.captchaSuccess = false;
    this.captchaIsExpired = true;
  }

  validateCaptcha(){

    let payload: any;
    payload = {

      captachResponse: this.captchaResponse,

    };
    this.customerService.validateCaptcha(payload).subscribe(res => {

      if(res['success']){

      }else{

        this.captchaElem.reloadCaptcha();
        this.captchaElem.resetCaptcha();

      }

    });
  }

  ngOnInit() {    
    this.reviewApplication();
    this.scrollToTop();
    this.activateHeader ='N';
}

  scrollToTop(){

    let data = document.getElementById('app');

    data.scrollIntoView({behavior: 'auto'});
    
  }

  backToApplication(){
    this._location.back();
  }

  reviewApplication(){

    this.buildReviewForm();
    this.reviewFormBuilder();
    this.buildReviewDocs();

  }

  reviewFormBuilder(){

    this.reviewForm = new FormGroup({
      myRecaptcha : new FormControl(null, [Validators.required])
    });
  }

  buildReviewForm(){

    this.messagesService.getReviewData().subscribe((resp => {

      this.customerForm =resp;

      let res = resp.value

      //Applicant info
      this.APPLICANT_NAME = res['APPLICANT_NAME'];
      this.DBA_NAME = res['DBA_NAME'];
      this.PHONE_AREA_CODE = res['PROSPECT_CONTACT'][0]['PHONE_AREA_CODE'];
      this.PHONE_NUMBER = res['PROSPECT_CONTACT'][0]['PHONE_NUMBER'];
      this.ADDRESS_LINE1 = res['PROSPECT_ADDRESS'][0]['ADDRESS_LINE1'];
      this.ADDRESS_LINE2 = res['PROSPECT_ADDRESS'][0]['ADDRESS_LINE2'];
      this.CITY = res['PROSPECT_ADDRESS'][0]['CITY'];
      this.STATE = res['PROSPECT_ADDRESS'][0]['STATE'];
      this.COUNTY = res['PROSPECT_ADDRESS'][0]['COUNTY'];
      this.POSTAL_CODE = res['PROSPECT_ADDRESS'][0]['POSTAL_CODE'];
      this.COUNTRY = res['PROSPECT_ADDRESS'][0]['COUNTRY'];
      this.BILL_ADR_SAME_SHIP_ADR = res['PROSPECT_ADDRESS'][0]['BILL_ADR_SAME_SHIP_ADR'];

      //Billing Address

      this.S_ADDRESS_LINE1 = res['PROSPECT_ADDRESS'][1]['ADDRESS_LINE1'];
      this.S_ADDRESS_LINE2 = res['PROSPECT_ADDRESS'][1]['ADDRESS_LINE2'];
      this.S_CITY = res['PROSPECT_ADDRESS'][1]['CITY'];
      this.S_STATE = res['PROSPECT_ADDRESS'][1]['STATE'];
      this.S_COUNTY = res['PROSPECT_ADDRESS'][1]['COUNTY'];
      this.S_POSTAL_CODE = res['PROSPECT_ADDRESS'][1]['POSTAL_CODE'];
      this.S_COUNTRY = res['PROSPECT_ADDRESS'][1]['COUNTRY'];


      //Communications
      this.EMAIL_ADDRESS = res['PROSPECT_CONTACT'][1]['EMAIL_ADDRESS'];
      //BUSINESS
      this.BUSINESS_TYPE = res['BUSINESS_TYPE'];
      //Business Identification
      this.STATE_ORG_ID = res['STATE_ORG_ID'];
      this.DNB_NUMBER = res['DNB_NUMBER'];
      this.JGZZ_FISCAL_CODE= res['JGZZ_FISCAL_CODE'];
      //Customer Info
      this.OWNER_FIRST_NAME = res['OWNER_FIRST_NAME'].trim();
      this.OWNER_LAST_NAME = res['OWNER_LAST_NAME'].trim();
      this.C_PHONE_AREA_CODE = res['PROSPECT_CONTACT'][2]['PHONE_AREA_CODE'];
      this.C_PHONE_NUMBER = res['PROSPECT_CONTACT'][2]['PHONE_NUMBER'];
      this.C_EMAIL_ADDRESS = res['PROSPECT_CONTACT'][3]['EMAIL_ADDRESS'];
      //Principle owner# 1
      this.P1_REF_NAME = res['PROSPECT_REFERENCE'][0]['REF_NAME'];
      this.P1_ADDRESS_LINE1 = res['PROSPECT_ADDRESS'][2]['ADDRESS_LINE1'];
      this.P1_ADDRESS_LINE2 = res['PROSPECT_ADDRESS'][2]['ADDRESS_LINE2'];
      this.P1_CITY = res['PROSPECT_ADDRESS'][2]['CITY'];
      this.P1_STATE = res['PROSPECT_ADDRESS'][2]['STATE'];
      this.P1_COUNTY = res['PROSPECT_ADDRESS'][2]['COUNTY'];
      this.P1_POSTAL_CODE = res['PROSPECT_ADDRESS'][2]['POSTAL_CODE'];
      this.P1_COUNTRY = res['PROSPECT_ADDRESS'][2]['COUNTRY'];
      this.P1_PHONE_AREA_CODE = res['PROSPECT_CONTACT'][4]['PHONE_AREA_CODE'];
      this.P1_PHONE_NUMBER = res['PROSPECT_CONTACT'][4]['PHONE_NUMBER'];
      this.P1_EMAIL_ADDRESS = res['PROSPECT_CONTACT'][5]['EMAIL_ADDRESS'];
      //Principle owner# 2
      this.P2_REF_NAME = res['PROSPECT_REFERENCE'][1]['REF_NAME'];
      this.P2_PHONE_AREA_CODE = res['PROSPECT_CONTACT'][6]['PHONE_AREA_CODE'];
      this.P2_PHONE_NUMBER = res['PROSPECT_CONTACT'][6]['PHONE_NUMBER'];
      this.P2_EMAIL_ADDRESS = res['PROSPECT_CONTACT'][7]['EMAIL_ADDRESS'];
      //TAX_EXEMPT
      this.IS_CUST_TAX_EXEMPT = res['IS_CUST_TAX_EXEMPT'];
      //Credit Application
      this.CREDIT_LIMIT_REQUESTED = res['CREDIT_LIMIT_REQUESTED'];
      this.CUSTOMER_REQUESTED_CREDIT= res['CUSTOMER_REQUESTED_CREDIT'];
      this.CUSTOMER_CREDIT_AUTHORIZED = res['CUSTOMER_CREDIT_AUTHORIZED'];
      //Type of Business
      this.TYPE_OF_BUSINESS = res['TYPE_OF_BUSINESS'];
      this.TYPE_OF_BUSINESS_DESC = res['TYPE_OF_BUSINESS_DESC'];
      this.YRS_IN_BUSINESS = res['YRS_IN_BUSINESS'];
      this.PO_REQUIRED = res['PO_REQUIRED'];
      this.PREMISIS= res['PREMISIS'];
      this.EST_ANNUAL_PUR_VOL= res['EST_ANNUAL_PUR_VOL'];
      //MJF Digital
      this.TAXABLE_ITEMS = res['TAXABLE_ITEMS'];
      this.PROPERTY_DESCRIPTION = res['PROPERTY_DESCRIPTION'];
      this.TAX_EXEMPTION_NUMBER = res['TAX_EXEMPTION_NUMBER'];
      this.TIRE_DISPOSAL_FEE = res['TIRE_DISPOSAL_FEE'];
      
      this.buildStatesCounty();      

    }));

    
  }

  trimSpaces(){
    if(this.P1_REF_NAME ){
      this.P1_REF_NAME  = this.P1_REF_NAME .trim();
    }
    if(this.P2_REF_NAME){
      this.P2_REF_NAME = this.P2_REF_NAME.trim();
    }
  }
  buildStatesCounty(){

    if(this.STATE !== null){
      this.STATE =this.STATE.split('@')[0];
      this.COUNTY = this.COUNTY.split('@')[0];  
    } else if (this.COUNTY !== null){
      this.COUNTY = this.COUNTY.split('@')[0];    
    }

      if(this.S_STATE !== null){
      this.S_STATE =this.S_STATE.split('@')[0];
      this.S_COUNTY = this.S_COUNTY.split('@')[0];
    } else if(this.S_COUNTY !== null){
      this.S_COUNTY = this.S_COUNTY.split('@')[0];
    }

    if(this.P1_STATE !== null){
      this.P1_STATE = this.P1_STATE.split('@')[0];
      this.P1_COUNTY =this.P1_COUNTY.split('@')[0]; 
    } else if(this.P1_COUNTY !== null){
      this.P1_COUNTY =this.P1_COUNTY.split('@')[0]; 
    }
  }

  buildReviewDocs(){

    this.messagesService.getDocData().subscribe((res => {

      this.blcDoc = res['blc'];
      this.stateTaxFiles = res['state'];
      this.apRemoveControl = res['apContact'];
      this.blcDocLabel = res['blcDocLabel'];
      this.stateTaxFilesLabels = res['stateTaxFilesLabels'];
      this.enableMjf = res['enableMjf'];


//apremovecontrol N-- credit app opened

//review state -- Y credit should open

if(this.apRemoveControl === 'N'){

        let obj = {
        reviewState:'Y',
      }

      this.messagesService.sendValidationData(obj);
}

if(this.apRemoveControl === 'Y'){

  let obj = {
  reviewState:'N',
}
this.messagesService.sendValidationData(obj);
}

    }));

  }


  initializeStates(){

    this.PROSPECT_ADDRESS = this.customerForm.get('PROSPECT_ADDRESS') as FormArray;

    

    this.applicantState = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[0]['STATE']);
    this.applicantCounty = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[0]['COUNTY']);

    //Shipping Address
    this.shippingState = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[1]['STATE']);
    this.shippingCounty = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[1]['COUNTY']);
    //Principle State
    this.principleState = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[2]['STATE']);
    this.principleCounty = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[2]['COUNTY']);
    //Principle two state
    this.principleTwoState = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[3]['STATE']);
    this.principleTwoCounty = this.removeSplCharOnStateOrCounty(this.customerForm.value.PROSPECT_ADDRESS[3]['COUNTY']);


    if(this.applicantState !== null){  

      this.applicantState = this.applicantState.split('@')[0];
      this.applicantCounty = this.applicantCounty.split('@')[0];


      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][0].controls['STATE'].setValue(this.applicantState);
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][0].controls['COUNTY'].setValue(this.applicantCounty);
    
     }

     if(this.shippingState !== null){  

      this.shippingState = this.shippingState.split('@')[0];
      this.shippingCounty = this.shippingCounty.split('@')[0];


      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][1].controls['STATE'].setValue(this.shippingState);
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][1].controls['COUNTY'].setValue(this.shippingCounty);
    
     }

    if(this.principleState !== null){  
      this.principleState = this.principleState.split('@')[0];
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['STATE'].setValue(this.principleState);
      } else if(this.principleCounty != null){
      this.principleCounty = this.principleCounty.split('@')[0];
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][2].controls['COUNTY'].setValue(this.principleCounty);
      }

     if(this.principleTwoState !== null){  
      this.principleTwoState = this.principleTwoState.split('@')[0];
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][3].controls['STATE'].setValue(this.principleTwoState);
     } else if(this.principleTwoCounty != null){
      this.principleTwoCounty = this.principleTwoCounty.split('@')[0];
      this.customerForm.controls['PROSPECT_ADDRESS']['controls'][3].controls['COUNTY'].setValue(this.principleTwoCounty);
     }
    
  }

  submitApplication(){
    // clearInterval(this.activateTimeInterval);
    this.PROSPECT_ADDRESS = this.customerForm.get('PROSPECT_ADDRESS') as FormArray;
    this.PROSPECT_REFERENCE = this.customerForm.get('PROSPECT_REFERENCE') as FormArray;
    this.PROSPECT_CONTACT = this.customerForm.get('PROSPECT_CONTACT') as FormArray;

    this.validateBtnState = ClrLoadingState.LOADING;

    if(this.BILL_ADR_SAME_SHIP_ADR === 'Y'){

       this.customerForm.controls['PROSPECT_ADDRESS']['controls'][1].patchValue(this.customerForm.controls['PROSPECT_ADDRESS']['controls'][0].value);
        this.customerForm.controls['PROSPECT_ADDRESS']['controls'][1].get('ADDRESS_TYPE').setValue('Bill_TO');
    }

   this.initializeStates();
    // Validates the county/State values with @
    for (let [key, values] of Object.entries(this.customerForm.value.PROSPECT_ADDRESS)) {
      let obj:any = values;
      for(var property in obj) {
        if(property =='COUNTY' || 'STATE'){
          this.customerForm.value.PROSPECT_ADDRESS[key][property] = this.removeSplCharOnStateOrCounty(obj[property]);
        }
    }
    }

    this.customerService.submitForm(this.customerForm.value).subscribe(res => {


      const uploadObservables = [];
      const applicationId = res['APPLICATION_ID'];
      this.blcDoc = ReviewComponent.renameFile(this.blcDoc, applicationId, 'BLC');

      if (this.stateTaxFiles.length > 0) {
        this.stateTaxFiles.forEach((sfFile, index) => {
          this.stateTaxFiles[index] = ReviewComponent.renameFile(sfFile, applicationId, `STF_${index}`);
          this.stateTaxFilesObjects[index] = {};
          uploadObservables.push(this.customerService.uploadDocs(this.stateTaxFiles[index], this.constructFileUploadObj(
            this.stateTaxFilesObjects[index], undefined, this.stateTaxFilesLabels[index], applicationId, `STF_${index}`, sfFile)));
        });
      }

      uploadObservables.push(this.customerService.uploadDocs(this.blcDoc,
        this.constructFileUploadObj(this.blcDocObject,
          this.blcDocB64,
          this.blcDocLabel,
          applicationId,
          'Business_License',
          this.blcDoc)));

      forkJoin(uploadObservables).subscribe(res => {

        // this.customerService.updateForm(applicationId).subscribe(res => {

          console.log('Processing update on Customer Application', applicationId);

        this.validateBtnState = ClrLoadingState.SUCCESS;
        this.messagesService.sendConfMessage(applicationId);
        this.router.navigate([`/confirmation/${applicationId}`]);

      // } );
    
    }, err => {

        // this.customerService.updateForm(applicationId).subscribe(res => {

          console.log('ERR Processing update on Customer Application', applicationId);

                 // this.handleError(err);
        this.validateBtnState = ClrLoadingState.SUCCESS;
        this.messagesService.sendConfMessage(applicationId);
        this.router.navigate([`/confirmation/${applicationId}`]);

        // } );

      });

    }, err => {

      this.handleError("Error: Sorry, we are unable to process the application.");

    });

   

    
  //  }));
  
  }

  public constructFileUploadObj(body, base64Obj, docName, applicationId, prefix, file) {

    const result = body;

    result.DOC_NAME = file.customName;
    result.LINK_TO_DOC = null;
    result.MYSQL_ORG_ID = this.mySQLOrgId;
    result.DOC_TYPE = prefix;
    result.APPLICATION_ID = applicationId;

    return JSON.stringify(result);
  }

  private handleError(errMessage?) {
    this.errorMessage = errMessage;
    this.showError = true;
    console.log(`Error Submitting the form : ${errMessage}`);
    const top = document.getElementById('errorMessage');
    this.scroll(top);
    this.validateBtnState = ClrLoadingState.DEFAULT;
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({behavior: 'smooth'});
  }

  removeSplCharOnStateOrCounty(value:any){
    let newvalue = value +'';
    if(newvalue){
      return newvalue.split('@')[0]; 
    }
    return newvalue;
  }

  public static renameFile(file, applicationId, prefix) {

    const resultFile = file;
    let resultFileType = resultFile.type.split('/')[1];
    const doc = 'msword';
    const docx = 'vnd.openxmlformats-officedocument.wordprocessingml.document';
    const xls = 'vnd.ms-excel';
    const xlsx = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    if(resultFileType === doc){
      resultFileType = 'doc';
    } else if(resultFileType === docx){
      resultFileType = 'docx';
    } else if(resultFileType === xls){
      resultFileType = 'xls';
    } else if(resultFileType === xlsx){
      resultFileType = 'xlsx';
    }

    resultFile.customName = `${prefix}_${applicationId}.${resultFileType}`;

    return resultFile;

  }
  
  

}
